module.exports = __webpack_public_path__ + "img/shopee-logo-connect.afde7a08.png";